import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

// http://specification.sifassociation.org/Implementation/AU/3.4.5/CodeSets.html#AUCodeSetsStandardAustralianClassificationOfCountriesSACCType
export default BaseEnum.create({
  values: [
    { value: '0000', label: 'Inadequately Described' },
    { value: '0001', label: 'At Sea' },
    { value: '0003', label: 'Not Stated' },
    {
      value: '0004',
      label:
        'Unknown (for use in economic statistics: the destination or origin of the goods is unknown)',
    },
    {
      value: '0005',
      label:
        'Unidentified (for use in economic statistics: the country reported on import/export documentation is not recognised)',
    },
    { value: '0611', label: 'Europe' },
    { value: '0612', label: 'Europe and the former USSR' },
    { value: '0613', label: 'Former USSR' },
    { value: '0614', label: 'Asia' },
    { value: '0615', label: 'East Asia' },
    { value: '0616', label: 'Africa' },
    { value: '0701', label: 'Africa, nec' },
    { value: '0702', label: 'Americas, nec' },
    { value: '0703', label: 'Asia, nec' },
    { value: '0704', label: 'Belgium and Luxembourg' },
    {
      value: '0705',
      label: 'Central America and the Caribbean (excludes Mexico)',
    },
    { value: '0706', label: 'Christmas Island' },
    { value: '0707', label: 'Cocos (Keeling) Islands' },
    {
      value: '0708',
      label:
        'Country Conf. Alumina (a secondary (International Trade specific) confidentiality restriction for exports of alumina to specific countries)',
    },
    { value: '0711', label: 'Denmark (includes Greenland and Faroe Islands)' },
    { value: '0712', label: 'Eurodollar Market' },
    { value: '0713', label: 'Europe, nec' },
    {
      value: '0714',
      label:
        'Falkland Islands (includes South Georgia and South Sandwich Islands)',
    },
    { value: '0715', label: 'France (includes Andorra and Monaco)' },
    { value: '0716', label: 'French Antilles (Guadeloupe and Martinique)' },
    { value: '0717', label: 'French Southern Territories' },
    { value: '0718', label: 'International Capital Markets' },
    { value: '0721', label: 'International Institutions' },
    {
      value: '0722',
      label:
        'International Waters (goods placed in the ocean outside any territorial waters or exclusive economic zone)',
    },
    { value: '0723', label: 'Italy (includes Holy See and San Marino)' },
    { value: '0724', label: 'Johnston and Sand Islands' },
    { value: '0725', label: 'Midway Islands' },
    {
      value: '0726',
      label: 'Morocco (includes places under Spanish sovereignty)',
    },
    {
      value: '0727',
      label:
        'No Country Details (overseas country detail for exports not available due to a confidentiality restriction)',
    },
    { value: '0728', label: 'Oceania, nec' },
    {
      value: '0741',
      label:
        'Reserve Bank Gold (gold, held by the Reserve Bank of Australia as part of reserve assets, that cannot be allocated by country)',
    },
    {
      value: '0742',
      label:
        "Ships' and Aircraft Stores (stores, including fuel, loaded onto foreign registered ships and aircraft)",
    },
    { value: '0743', label: 'Switzerland (includes Liechtenstein)' },
    { value: '0744', label: 'United States Miscellaneous Islands' },
    { value: '0745', label: 'Wake Island' },
    {
      value: '0746',
      label:
        'Australia (includes External Territories, Australian Antarctic Territory and Norfolk Island)',
    },
    {
      value: '0747',
      label:
        'JPDA (Joint Petroleum Development Area - administered by Australia and Timor-Leste)',
    },
    { value: '0911', label: 'Europe, nfd' },
    { value: '0912', label: 'Former USSR, nfd' },
    { value: '0913', label: 'Former Yugoslavia, nfd' },
    { value: '0914', label: 'Czechoslovakia, nfd' },
    { value: '0915', label: 'Kurdistan, nfd' },
    { value: '0916', label: 'East Asia, nfd' },
    { value: '0917', label: 'Asia, nfd' },
    { value: '0918', label: 'Africa, nfd' },
    { value: '0921', label: 'Serbia and Montenegro, nfd' },
    { value: '0922', label: 'Channel Islands, nfd' },
    { value: '0924', label: 'Netherlands Antilles, nfd' },
    { value: '1000', label: 'Oceania and Antarctica, nfd' },
    { value: '1100', label: 'Australia (includes External Territories, nfd)' },
    { value: '1101', label: 'Australia' },
    { value: '1102', label: 'Norfolk Island' },
    { value: '1199', label: 'Australian External Territories, nec' },
    { value: '1201', label: 'New Zealand' },
    { value: '1300', label: 'Melanesia, nfd' },
    { value: '1301', label: 'New Caledonia' },
    { value: '1302', label: 'Papua New Guinea' },
    { value: '1303', label: 'Solomon Islands' },
    { value: '1304', label: 'Vanuatu' },
    { value: '1400', label: 'Micronesia, nfd' },
    { value: '1401', label: 'Guam' },
    { value: '1402', label: 'Kiribati' },
    { value: '1403', label: 'Marshall Islands' },
    { value: '1404', label: 'Micronesia, Federated States of' },
    { value: '1405', label: 'Nauru' },
    { value: '1406', label: 'Northern Mariana Islands' },
    { value: '1407', label: 'Palau' },
    { value: '1500', label: 'Polynesia (excludes Hawaii), nfd' },
    { value: '1501', label: 'Cook Islands' },
    { value: '1502', label: 'Fiji' },
    { value: '1503', label: 'French Polynesia' },
    { value: '1504', label: 'Niue' },
    { value: '1505', label: 'Samoa' },
    { value: '1506', label: 'Samoa, American' },
    { value: '1507', label: 'Tokelau' },
    { value: '1508', label: 'Tonga' },
    { value: '1511', label: 'Tuvalu' },
    { value: '1512', label: 'Wallis and Futuna' },
    { value: '1513', label: 'Pitcairn Islands' },
    { value: '1599', label: 'Polynesia (excludes Hawaii), nec' },
    { value: '1600', label: 'Antarctica, nfd' },
    { value: '1601', label: 'Adelie Land (France)' },
    { value: '1602', label: 'Argentinian Antarctic Territory' },
    { value: '1603', label: 'Australian Antarctic Territory' },
    { value: '1604', label: 'British Antarctic Territory' },
    { value: '1605', label: 'Chilean Antarctic Territory' },
    { value: '1606', label: 'Queen Maud Land (Norway)' },
    { value: '1607', label: 'Ross Dependency (New Zealand)' },
    { value: '2000', label: 'North-West Europe, nfd' },
    {
      value: '2100',
      label: 'United Kingdom, Channels Islands and Isle of Man, nfd',
    },
    { value: '2102', label: 'England' },
    { value: '2103', label: 'Isle of Man' },
    { value: '2104', label: 'Northern Ireland' },
    { value: '2105', label: 'Scotland' },
    { value: '2106', label: 'Wales' },
    { value: '2107', label: 'Guernsey' },
    { value: '2108', label: 'Jersey' },
    { value: '2201', label: 'Ireland' },
    { value: '2300', label: 'Western Europe, nfd' },
    { value: '2301', label: 'Austria' },
    { value: '2302', label: 'Belgium' },
    { value: '2303', label: 'France' },
    { value: '2304', label: 'Germany' },
    { value: '2305', label: 'Liechtenstein' },
    { value: '2306', label: 'Luxembourg' },
    { value: '2307', label: 'Monaco' },
    { value: '2308', label: 'Netherlands' },
    { value: '2311', label: 'Switzerland' },
    { value: '2400', label: 'Northern Europe, nfd' },
    { value: '2401', label: 'Denmark' },
    { value: '2402', label: 'Faroe Islands' },
    { value: '2403', label: 'Finland' },
    { value: '2404', label: 'Greenland' },
    { value: '2405', label: 'Iceland' },
    { value: '2406', label: 'Norway' },
    { value: '2407', label: 'Sweden' },
    { value: '2408', label: 'Aland Islands' },
    { value: '3000', label: 'Southern and Eastern Europe, nfd' },
    { value: '3100', label: 'Southern Europe, nfd' },
    { value: '3101', label: 'Andorra' },
    { value: '3102', label: 'Gibraltar' },
    { value: '3103', label: 'Holy See' },
    { value: '3104', label: 'Italy' },
    { value: '3105', label: 'Malta' },
    { value: '3106', label: 'Portugal' },
    { value: '3107', label: 'San Marino' },
    { value: '3108', label: 'Spain' },
    { value: '3200', label: 'South Eastern Europe, nfd' },
    { value: '3201', label: 'Albania' },
    { value: '3202', label: 'Bosnia and Herzegovina' },
    { value: '3203', label: 'Bulgaria' },
    { value: '3204', label: 'Croatia' },
    { value: '3205', label: 'Cyprus' },
    { value: '3206', label: 'The former Yugoslav Republic of Macedonia' },
    { value: '3207', label: 'Greece' },
    { value: '3208', label: 'Moldova' },
    { value: '3211', label: 'Romania' },
    { value: '3212', label: 'Slovenia' },
    { value: '3214', label: 'Montenegro' },
    { value: '3215', label: 'Serbia' },
    { value: '3216', label: 'Kosovo' },
    { value: '3300', label: 'Eastern Europe, nfd' },
    { value: '3301', label: 'Belarus' },
    { value: '3302', label: 'Czech Republic' },
    { value: '3303', label: 'Estonia' },
    { value: '3304', label: 'Hungary' },
    { value: '3305', label: 'Latvia' },
    { value: '3306', label: 'Lithuania' },
    { value: '3307', label: 'Poland' },
    { value: '3308', label: 'Russian Federation' },
    { value: '3311', label: 'Slovakia' },
    { value: '3312', label: 'Ukraine' },
    { value: '4000', label: 'North Africa and the Middle East, nfd' },
    { value: '4100', label: 'North Africa, nfd' },
    { value: '4101', label: 'Algeria' },
    { value: '4102', label: 'Egypt' },
    { value: '4103', label: 'Libya' },
    { value: '4104', label: 'Morocco' },
    { value: '4105', label: 'Sudan' },
    { value: '4106', label: 'Tunisia' },
    { value: '4107', label: 'Western Sahara' },
    { value: '4108', label: 'Spanish North Africa' },
    { value: '4111', label: 'South Sudan' },
    { value: '4200', label: 'Middle East, nfd' },
    { value: '4201', label: 'Bahrain' },
    { value: '4202', label: 'Gaza Strip and West Bank' },
    { value: '4203', label: 'Iran' },
    { value: '4204', label: 'Iraq' },
    { value: '4205', label: 'Israel' },
    { value: '4206', label: 'Jordan' },
    { value: '4207', label: 'Kuwait' },
    { value: '4208', label: 'Lebanon' },
    { value: '4211', label: 'Oman' },
    { value: '4212', label: 'Qatar' },
    { value: '4213', label: 'Saudi Arabia' },
    { value: '4214', label: 'Syria' },
    { value: '4215', label: 'Turkey' },
    { value: '4216', label: 'United Arab Emirates' },
    { value: '4217', label: 'Yemen' },
    { value: '5000', label: 'South-East Asia, nfd' },
    { value: '5100', label: 'Mainland South-East Asia, nfd' },
    { value: '5101', label: 'Myanmar' },
    { value: '5102', label: 'Cambodia' },
    { value: '5103', label: 'Laos' },
    { value: '5104', label: 'Thailand' },
    { value: '5105', label: 'Vietnam' },
    { value: '5200', label: 'Maritime South-East Asia, nfd' },
    { value: '5201', label: 'Brunei Darussalam' },
    { value: '5202', label: 'Indonesia' },
    { value: '5203', label: 'Malaysia' },
    { value: '5204', label: 'Philippines' },
    { value: '5205', label: 'Singapore' },
    { value: '5206', label: 'Timor-Leste' },
    { value: '6000', label: 'North-East Asia, nfd' },
    { value: '6100', label: 'Chinese Asia (includes Mongolia), nfd' },
    { value: '6101', label: 'China (excludes SARs and Taiwan)' },
    { value: '6102', label: 'Hong Kong (SAR of China)' },
    { value: '6103', label: 'Macau (SAR of China)' },
    { value: '6104', label: 'Mongolia' },
    { value: '6105', label: 'Taiwan' },
    { value: '6200', label: 'Japan and the Koreas, nfd' },
    { value: '6201', label: 'Japan' },
    { value: '6202', label: "Korea, Democratic People's Republic of (North)" },
    { value: '6203', label: 'Korea, Republic of (South)' },
    { value: '7000', label: 'Southern and Central Asia, nfd' },
    { value: '7100', label: 'Southern Asia, nfd' },
    { value: '7101', label: 'Bangladesh' },
    { value: '7102', label: 'Bhutan' },
    { value: '7103', label: 'India' },
    { value: '7104', label: 'Maldives' },
    { value: '7105', label: 'Nepal' },
    { value: '7106', label: 'Pakistan' },
    { value: '7107', label: 'Sri Lanka' },
    { value: '7200', label: 'Central Asia, nfd' },
    { value: '7201', label: 'Afghanistan' },
    { value: '7202', label: 'Armenia' },
    { value: '7203', label: 'Azerbaijan' },
    { value: '7204', label: 'Georgia' },
    { value: '7205', label: 'Kazakhstan' },
    { value: '7206', label: 'Kyrgyzstan' },
    { value: '7207', label: 'Tajikistan' },
    { value: '7208', label: 'Turkmenistan' },
    { value: '7211', label: 'Uzbekistan' },
    { value: '8000', label: 'Americas, nfd' },
    { value: '8100', label: 'Northern America, nfd' },
    { value: '8101', label: 'Bermuda' },
    { value: '8102', label: 'Canada' },
    { value: '8103', label: 'St Pierre and Miquelon' },
    { value: '8104', label: 'United States of America' },
    { value: '8200', label: 'South America, nfd' },
    { value: '8201', label: 'Argentina' },
    { value: '8202', label: 'Bolivia' },
    { value: '8203', label: 'Brazil' },
    { value: '8204', label: 'Chile' },
    { value: '8205', label: 'Colombia' },
    { value: '8206', label: 'Ecuador' },
    { value: '8207', label: 'Falkland Islands' },
    { value: '8208', label: 'French Guiana' },
    { value: '8211', label: 'Guyana' },
    { value: '8212', label: 'Paraguay' },
    { value: '8213', label: 'Peru' },
    { value: '8214', label: 'Suriname' },
    { value: '8215', label: 'Uruguay' },
    { value: '8216', label: 'Venezuela' },
    { value: '8299', label: 'South America, nec' },
    { value: '8300', label: 'Central America, nfd' },
    { value: '8301', label: 'Belize' },
    { value: '8302', label: 'Costa Rica' },
    { value: '8303', label: 'El Salvador' },
    { value: '8304', label: 'Guatemala' },
    { value: '8305', label: 'Honduras' },
    { value: '8306', label: 'Mexico' },
    { value: '8307', label: 'Nicaragua' },
    { value: '8308', label: 'Panama' },
    { value: '8400', label: 'Caribbean, nfd' },
    { value: '8401', label: 'Anguilla' },
    { value: '8402', label: 'Antigua and Barbuda' },
    { value: '8403', label: 'Aruba' },
    { value: '8404', label: 'Bahamas' },
    { value: '8405', label: 'Barbados' },
    { value: '8406', label: 'Cayman Islands' },
    { value: '8407', label: 'Cuba' },
    { value: '8408', label: 'Dominica' },
    { value: '8411', label: 'Dominican Republic' },
    { value: '8412', label: 'Grenada' },
    { value: '8413', label: 'Guadeloupe' },
    { value: '8414', label: 'Haiti' },
    { value: '8415', label: 'Jamaica' },
    { value: '8416', label: 'Martinique' },
    { value: '8417', label: 'Montserrat' },
    { value: '8421', label: 'Puerto Rico' },
    { value: '8422', label: 'St Kitts and Nevis' },
    { value: '8423', label: 'St Lucia' },
    { value: '8424', label: 'St Vincent and the Grenadines' },
    { value: '8425', label: 'Trinidad and Tobago' },
    { value: '8426', label: 'Turks and Caicos Islands' },
    { value: '8427', label: 'Virgin Islands, British' },
    { value: '8428', label: 'Virgin Islands, United States' },
    { value: '8431', label: 'St Barthelemy' },
    { value: '8432', label: 'St Martin (French part)' },
    { value: '8433', label: 'Bonaire, Sint Eustatius and Saba' },
    { value: '8434', label: 'Curacao' },
    { value: '8435', label: 'Sint Maarten (Dutch part)' },
    { value: '9000', label: 'Sub-Saharan Africa, nfd' },
    { value: '9100', label: 'Central and West Africa, nfd' },
    { value: '9101', label: 'Benin' },
    { value: '9102', label: 'Burkina Faso' },
    { value: '9103', label: 'Cameroon' },
    { value: '9104', label: 'Cabo Verde' },
    { value: '9105', label: 'Central African Republic' },
    { value: '9106', label: 'Chad' },
    { value: '9107', label: 'Congo, Republic of' },
    { value: '9108', label: 'Congo, Democratic Republic of' },
    { value: '9111', label: "Cote d'Ivoire" },
    { value: '9112', label: 'Equatorial Guinea' },
    { value: '9113', label: 'Gabon' },
    { value: '9114', label: 'Gambia' },
    { value: '9115', label: 'Ghana' },
    { value: '9116', label: 'Guinea' },
    { value: '9117', label: 'Guinea-Bissau' },
    { value: '9118', label: 'Liberia' },
    { value: '9121', label: 'Mali' },
    { value: '9122', label: 'Mauritania' },
    { value: '9123', label: 'Niger' },
    { value: '9124', label: 'Nigeria' },
    { value: '9125', label: 'Sao Tome and Principe' },
    { value: '9126', label: 'Senegal' },
    { value: '9127', label: 'Sierra Leone' },
    { value: '9128', label: 'Togo' },
    { value: '9200', label: 'Southern and East Africa, nfd' },
    { value: '9201', label: 'Angola' },
    { value: '9202', label: 'Botswana' },
    { value: '9203', label: 'Burundi' },
    { value: '9204', label: 'Comoros' },
    { value: '9205', label: 'Djibouti' },
    { value: '9206', label: 'Eritrea' },
    { value: '9207', label: 'Ethiopia' },
    { value: '9208', label: 'Kenya' },
    { value: '9211', label: 'Lesotho' },
    { value: '9212', label: 'Madagascar' },
    { value: '9213', label: 'Malawi' },
    { value: '9214', label: 'Mauritius' },
    { value: '9215', label: 'Mayotte' },
    { value: '9216', label: 'Mozambique' },
    { value: '9217', label: 'Namibia' },
    { value: '9218', label: 'Reunion' },
    { value: '9221', label: 'Rwanda' },
    { value: '9222', label: 'St Helena' },
    { value: '9223', label: 'Seychelles' },
    { value: '9224', label: 'Somalia' },
    { value: '9225', label: 'South Africa' },
    { value: '9226', label: 'Swaziland' },
    { value: '9227', label: 'Tanzania' },
    { value: '9228', label: 'Uganda' },
    { value: '9231', label: 'Zambia' },
    { value: '9232', label: 'Zimbabwe' },
    { value: '9299', label: 'Southern and East Africa, nec' },
  ],
});
